<script lang="ts">
    import SafeHtml from '@components/safe-html';
    import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';
    import type { DescriptionDto } from '@views/description/types';

    let { description }: DescriptionDto = $props();

    let expanderElement: HTMLOcExpanderV1Element | undefined = $state();
    $effect(() => {
        if (!expanderElement) return;

        trackView({
            product_Description: [expanderElement.isCutOff ? 'foldable' : 'not_foldable'],
        });
    });

    const trackFunction = (action: 'more' | 'less') => () => trackEvent({ product_Description: [action] });
</script>

{#if description}
    <div
        class="pdp_description oc-background-color-canvas oc-px-100 oc-pb-150"
        data-ft5-visibility-tracking={JSON.stringify({ componentName: 'description' })}
    >
        <oc-expander-v1
            bind:this={expanderElement}
            class="oc-copy-100"
            variant="text"
            cutoff-height={200}
            oc-aria-label="Description expander"
            onoc-open={trackFunction('more')}
            onoc-close={trackFunction('less')}
        >
            <SafeHtml html={description} />
        </oc-expander-v1>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    .pdp_description {
        :global(h3) {
            font-size: tokens.$oc-base-font-size-100;
            line-height: tokens.$oc-base-font-line-height-150;
            margin-bottom: tokens.$oc-semantic-spacing-absolute-50;
        }

        :global(h4) {
            font-size: tokens.$oc-base-font-size-100;
            line-height: tokens.$oc-base-font-line-height-100;
            font-weight: bold;
            margin-bottom: tokens.$oc-semantic-spacing-absolute-25;
        }

        :global(ul) {
            margin: 10px 0 10px 17px;
        }

        :global(li) {
            list-style-type: disc;
        }
    }
</style>
